import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LinearProgress, Stack } from '@mui/material';

import useResponsive from '@app/hooks/use-responsive';
import { RecipeCard } from '@app/components';
import { useRequestState } from '@app/hooks';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { favoriteItemsList } from '../slice';
import { getFavoriteItems } from '../selectors';

const FavoritesScreen = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const isMobile = useResponsive('down', 'md');
  const isTab = useResponsive('down', 'lg');

  const { loading, data } = useRequestState({
    stateSelector: getFavoriteItems,
    errorShown: true,
  });

  const RenderItem = ({ item }: any, key: number) => {
    
    return (
      <Stack sx={{ borderRadius: '10px', width: isMobile ? '100%' : isTab ? 400 : 550 }}>
        <RecipeCard
          key={key}
          image={item?.image}
          dishName={item?.label}
          cookingTime={`${item.totalTime} min`}
          ratings={item?.ratings || 'No Rating Yet'}
          description={item.label || item.description}
          id={item?.uri}
          onClick={() => navigation(PATH_DASHBOARD.recipeDetailsScreen, { state: item })}
        />
      </Stack>
    );
  };

  useEffect(() => {
    dispatch(favoriteItemsList());
  }, []);

  return (
    <Stack>
      {loading ? (
        <LinearProgress sx={{ mt: 20 }} />
      ) : (
        <Stack
          style={{
            flexDirection: 'row',
            gap: 15,
            width: isMobile ? '' : '90%',
            flexWrap: 'wrap',
            marginTop: 10,
            alignSelf: 'center',
          }}
        >
          {data?.map((item: any, index: number) => <RenderItem key={index} item={item} />)}
        </Stack>
      )}
    </Stack>
  );
};

export { FavoritesScreen };
